module.exports = __webpack_public_path__ + "img/sort／web／Action@2x.e82663f2.png";